import React, {useEffect, useState, useContext} from 'react';
import { Col, Card } from 'react-bootstrap';
import { VesselRankingsState, PortRankingsState } from '../types/type';
import { UserContext } from "../context/UserContext";

export default ({
  sectionType
}, {
  sectionType: String
}) =>  {
  const userState = useContext(UserContext);

  const [vesselRankings, setVesselRankings] = useState<[VesselRankingsState] | null>(null)
  const [portRankings, setPortRankings] = useState<[PortRankingsState] | null>(null)
  
  useEffect(() => { 
    async function init() {
      if (userState.role === 'admin') {
        let response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/base/vesselRankings`);
        setVesselRankings((await response.json()));
        response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/base/PortRankings`);
        setPortRankings((await response.json()));
      } else {
        let response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/base/myVesselRankings?apikey=${userState.apikey}`);
        setVesselRankings((await response.json()));
        response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/base/myPortRankings?apikey=${userState.apikey}`);
        setPortRankings((await response.json()));
      }
    }
    init()
  }, [])

  return (
    <React.Fragment>
        <Col>
          <Card>
            <Card.Body>
              <Card.Title style={{textAlign: "center"}}>Classificações de Embarcações</Card.Title>
              <Card.Subtitle style={{textAlign: "center"}} className="mb-2 text-muted">
                  {
                      userState.role === 'admin' && vesselRankings && vesselRankings.map((vessel) => <div>{vessel.NationalClassification + "º " + vessel.Vessel + " => " + vessel.PointsEarned + " Pontos"}</div>)
                  } 
                  {
                    userState.role !== 'admin'  && vesselRankings && vesselRankings.map((vessel) => <div>{vessel["Classificação Nacional"] + "º " + vessel.Barco + " => " + vessel.Pontos + " Pontos"}</div>)
                  }
                  </Card.Subtitle>
            </Card.Body>
          </Card> 
        </Col>
        <Col>
          <Card>
            <Card.Body>
              <Card.Title style={{textAlign: "center"}}>Classificações de Entregas nos Portos</Card.Title>
              <Card.Subtitle style={{textAlign: "center"}} className="mb-2 text-muted">
                  {
                      userState.role === 'admin' && portRankings && portRankings.map((port) => <div>{port.PortClassification + "º " + port.Name + " => " + port.PointsEarned + " Pontos"}</div>)
                  } 
                  {
                    userState.role !== 'admin'  && portRankings && portRankings.map((port) => <div>{port["Classificação"] + "º " + port.Porto + "("+ port.Barco +") => " + port.Pontos + " Pontos"}</div>)
                  }
                  </Card.Subtitle>
            </Card.Body>
          </Card> 
        </Col>
    </React.Fragment>
  )
}
